import React, { useEffect, useRef } from 'react'

import * as THREE from 'three'


function Galaxy({dof, galaxy, name, style, reduceParticles=false}) {

    // {
    //     count: 100000,
    //     radius: 6,
    //     spin: 1.25, //+clockwise, -anticlockwise
    //     branches: 4,
    //     randomness: 0.3, // width of branches
    //     randomnessPower: 3,
    //     colorInside: [1.0, 0.3765, 0.1882],
    //     colorOutside: [0.10588, 0.22353, 0.51765]
    // }

    const particles = useRef()
  
    useEffect(() => {
      generateGalaxy()
    })
  
  
    const generateGalaxy = () => {
      const positions = new Float32Array(style.count * 3)
      const colors = new Float32Array(style.count * 3)
      const colorInside = new THREE.Color(style.colorInside[0], style.colorInside[1], style.colorInside[2])
      const colorOutside = new THREE.Color(style.colorOutside[0], style.colorOutside[1], style.colorOutside[2])
      
      let defaultFactorize = 1
      if(reduceParticles){
        defaultFactorize = 10
      }
      for (let i = 0; i < parseInt(style.count/defaultFactorize); i++) {
        const i3 = i * 3
  
        const radius = Math.random() * style.radius
        const spinAngle = radius * style.spin
        const branchAngle = ((i % style.branches) / style.branches) * Math.PI * 2
  
        const randomX = Math.pow(Math.random(), style.randomnessPower) * (Math.random() < 0.5 ? 1 : -1) * style.randomness * radius
        const randomY = Math.pow(Math.random(), style.randomnessPower) * (Math.random() < 0.5 ? 1 : -1) * style.randomness * radius
        const randomZ = Math.pow(Math.random(), style.randomnessPower) * (Math.random() < 0.5 ? 1 : -1) * style.randomness * radius
  
        positions[i3] = Math.cos(branchAngle + spinAngle) * radius + randomX
        positions[i3 + 1] = randomY
        positions[i3 + 2] = Math.sin(branchAngle + spinAngle) * radius + randomZ
  
        const mixedColor = colorInside.clone()
        mixedColor.lerp(colorOutside, radius / style.radius)
  
        colors[i3] = mixedColor.r
        colors[i3 + 1] = mixedColor.g
        colors[i3 + 2] = mixedColor.b
      }
  
      particles.current.geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))
      particles.current.geometry.setAttribute('color', new THREE.BufferAttribute(colors, 3))
    }


    
  
    return (
      <points ref={particles}>
        <bufferGeometry />
        <pointsMaterial size={0.001} sizeAttenuation={true} depthWrite={true} vertexColors={true} blending={THREE.AdditiveBlending} />
      </points>
    )
  }

  
  export default Galaxy
  